angular.module('impactx.search').controller('ProductGroupItemCtrl', [
    'TranslationService',
    'AppConfiguration',
    '$redirect',
    ProductGroupItemCtrl
]);

function ProductGroupItemCtrl(TranslationService, AppConfiguration, $redirect) {
    var self = this;
    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.$onInit = function(){
        self.trns = {
            productLabel: (self.productGroup.numberOfProducts > 1 || self.productGroup.numberOfProducts === 0) ?
                TranslationService.get('products') : TranslationService.get('product')
        };
    };

    self.redirectToDetails = function () {
        $redirect.redirectTo(null, "vcatalog/" + self.productGroup.vCatId + "/" + self.productGroup.id);
    };
}
